// LICENSE_CODE TLM
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link, useLocation} from 'react-router';
import {Col, Row, Avatar, Button, Space, Typography} from 'antd';
import auth from './auth.js';
import eserf from '../../../util/eserf.js';
import je from '../../../util/je.js';
import back_app from './back_app.js';
import {Clickable} from './comp.js';

let {Title, Text} = Typography;
let E = ()=>{
  let {t} = useTranslation();
  let location = useLocation();
  let search = location.search;
  let {user, get_access_token_silently} = auth.use_auth_ext();
  let user_email_resend = ()=>eserf(function* _user_email_resend(){
    let res = yield auth.token_get(get_access_token_silently);
    yield back_app.user_email_resend(res.token, user.email);
  });
  let [is_focus, set_is_focus] = useState(true);
  useEffect(()=>{
    const focus_cb = ()=>set_is_focus(true);
    const blur_cb = ()=>set_is_focus(false);
    window.addEventListener('focus', focus_cb);
    window.addEventListener('blur', blur_cb);
    return ()=>{
      window.removeEventListener('focus', focus_cb);
      window.removeEventListener('blur', blur_cb);
    };
  }, []);
  useEffect(()=>{
    let es = eserf(function* email_verif_focus(){
      if (!is_focus || user.email_verified)
        return;
      while (1)
      {
        let res = yield auth.token_get(get_access_token_silently);
        let user_full = yield back_app.user_get(res.token, user.email);
        if (!user_full.err || (/is not.*org/u).test(user_full.err_data.err))
        {
          je.set('auth.is_email_verif', true);
          je.set_inc('email_verif.update_n');
          break;
        }
        yield eserf.sleep(5000);
      }
    });
    return ()=>es.return();
  }, [is_focus, get_access_token_silently, user]);
  return (
    <>
      <Row justify="center">
        <Col span={20}>
          {!user.email_verified && <Row>
            <Col>
              <Space direction="vertical" size="large" align="center">
                <Row>
                  <Col>
                    <Title level={2}>
                      {t('Please go and verify your email so you can '
                        +'continue to use the website. We sent you an '
                        +'email with a link to click on.')}
                    </Title>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Avatar src={user.picture}/></Col>
                  <Col>
                    <Title level={5}>{user.email}</Title>
                    {user.name && <Text>{user.name}</Text>}
                  </Col>
                </Row>
                <Row>
                  <Button onClick={user_email_resend}>
                    {t('Resend verification email')}
                  </Button>
                </Row>
              </Space>
            </Col>
          </Row>}
          {user.email_verified && <Row>
            <Title level={2}>{t('Thank you for verifing your email')}</Title>
            <Clickable>
              <Button>
                <Link to={{pathname: '/grouper', search}}>
                  {t('Start Grouping')}</Link>
              </Button>
            </Clickable>
          </Row>}
        </Col>
      </Row>
    </>
  );
};

export default auth.with_auth_req(E);
